import React from 'react'
import logger from 'loglevel'
import prefix from 'loglevel-plugin-prefix'

export interface LoggerProps {
    log: logger.Logger
}

export const withLogger = <OriginalProps extends {}>(
    displayName: string,
    WrappedComponent: React.ComponentType<OriginalProps & LoggerProps>,
) => {

    type ResultProps = OriginalProps;

    return class extends React.Component<ResultProps> {
        static displayName: string = `withLogger(${WrappedComponent.displayName})`
        log: logger.Logger

        constructor(props: Readonly<OriginalProps>) {
            super(props)

            prefix.reg(logger)
            this.log = logger.getLogger(displayName)

            switch (process.env.NODE_ENV) {
                case 'development':
                    this.log.setLevel(logger.levels.DEBUG)
                    break
                case 'test':
                    this.log.setLevel(logger.levels.WARN)
                    break
                default:
                    prefix.apply(logger, {
                        format(level: any, name: any, timestamp: any): string {
                            return `[${timestamp}] ${level} ${name}:`
                        },
                    })

                    this.log.setLevel(logger.levels.ERROR)
                    break
            }
        }

        render(): JSX.Element {
            return <WrappedComponent {...this.props} log={this.log}/>
        }
    }
}
